import React from 'react';
import styled from 'styled-components';
import { ColorSystemPositive2 } from 'autogen/design-tokens/tokens';
import { bubblePulse } from 'modules/helpers/animations';

const Wrapper = styled.div<{ left?: number }>`
    position: absolute;
    left: ${({ left }) => `${left}px` || 'initial'};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: ${ColorSystemPositive2};
`;

const AnimatedDot = styled.div`
    position: relative;
    z-index: -1;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: color-mix(in srgb, ${ColorSystemPositive2}, white 50%);
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    border-radius: 50%;
    animation: ${bubblePulse(1)} 5s linear infinite;

    &::after {
        content: '';
        display: block;
        width: inherit;
        height: inherit;
        border-radius: inherit;
        background-color: inherit;
        animation: ${bubblePulse()} 5s linear infinite;
    }
`;

interface IProps {
    left?: number;
}

const StatusIndicator = (props: IProps): JSX.Element => {
    const { left } = props;
    return (
        <Wrapper left={left}>
            <AnimatedDot />
        </Wrapper>
    );
};

export default StatusIndicator;
